module.exports = __webpack_public_path__ + "static/media/contact.2de3a8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact.jpg
// module id = 418
// module chunks = 0